// BrandToast.tsx
import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../../styles/custom/upgrade.css';

interface BrandToastProps {
  position?: 'top-right' | 'bottom-right' | 'top-center' | 'bottom-center';
}

const BrandToast: React.FC<BrandToastProps> = ({
  position = 'top-right',
}) => (
  <ToastContainer
    position={position}
    limit={5}
    className={`custom-toast-container custom-toast-container--${position}`}
    toastClassName="custom-toast"
    closeButton={({ closeToast }) => (
      <button onClick={closeToast} className="custom-toast-close">
        ×
      </button>
    )}
  />
);

export default BrandToast;
